import { render, staticRenderFns } from "./Negocial.vue?vue&type=template&id=1e94fca5&"
import script from "./Negocial.vue?vue&type=script&lang=js&"
export * from "./Negocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports